import { Injectable } from '@angular/core';
import {HttpInterceptor,HttpRequest,HttpHandler,HttpEvent,HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from "rxjs/operators";
import { ToasterService } from './toaster.service';
import {StorageService} from "./storage.service";
import{Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService {

  constructor(
    public toaster : ToasterService,
    public storage : StorageService,
    public router : Router) { }

      intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token  = this.storage.getUserToken();
        req = req.clone({
          setHeaders: {
              Authorization: token?token:''
          }
        });
        // return next.handle(req)
        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.toaster.Error("Please login again", "Session Expired");
              this.storage.DeleteUserStorageData();
              this.storage.deleteUserToken();
              this.router.navigate(["/auth/login"]);
            }
            return throwError(error);
          })
        );
      }  
        // return next.handle(request).pipe(catchError((error: HttpErrorResponse) => {
        //     let errorMessage = '';
        //     if (error instanceof HttpErrorResponse && error.status === 401) {
        //         this.storage.DeleteUserStorageData();
        //         this.storage.deleteUserToken();
        //         this.router.navigate(['auth/login']);
        //     }
        //   return throwError(errorMessage);
        // }))
}
